'use client';

import { DashboardTravelItineraryIntroduction } from '@tuic/web-compositions/my-trips/DashboardTravelItineraryIntroduction';

import type { ComponentBlock } from '@modules/prism-client/types/types';
import type { DashboardTravelItineraryIntroductionProps } from '@tuic/web-compositions/my-trips/DashboardTravelItineraryIntroduction';

export type TransitInstructionsBlockData =
  DashboardTravelItineraryIntroductionProps;

export const TransitInstructionsBlock: ComponentBlock<
  TransitInstructionsBlockData
> = ({ data, fallback }) => {
  if (fallback) {
    return <DashboardTravelItineraryIntroduction fallback />;
  }

  if (!data) {
    return null;
  }

  return (
    <DashboardTravelItineraryIntroduction {...data} button={data.button} />
  );
};
